module.exports = __webpack_public_path__ + "img/print_footprint.68f2cc3.jpg";